export const invalidateQueries = async (client, queries) => {
  await Promise.all(
    queries.map((key) => {
      return client.invalidateQueries(key);
    }),
  );
};
